<template>
  <v-dialog :value="isActive" persistent max-width="600" scrollable>
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ isEditMode ? "Actualizar" : "Crear" }} pregunta
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true }
          }"
        >
          <v-card-text style="max-height: 450px">
            <v-row>
              <!-- Opción -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider
                  name="pregunta"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-textarea
                    v-model="payload.question"
                    :error-messages="errors"
                    label="Pregunta"
                    rounded
                    filled
                    class="rounded-lg"
                  ></v-textarea>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn
            @click="closeDialog()"
            class="px-8"
            color="error"
            rounded
            large
            text
          >
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            @click="handleSubmit(submitForm)"
            :disabled="isLoading"
            class="px-8"
            color="success"
            rounded
            large
          >
            {{ isEditMode ? "Actualizar" : "Crear" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
import axios from "axios";

export default {
  components: {
    vuescroll
  },

  props: {
    isActive: {
      type: Boolean
    },
    isEditMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: {}
    },
    dataToEdit: {
      type: Object,
      default: {}
    }
  },

  data() {
    return {
      isLoading: false,
      queueList: [],
      clientList: [],
      payload: {
        question: ""
      }
    };
  },

  created() {
    this.payload = { ...this.dataToEdit };
  },

  methods: {
    resetform() {
      this.payload.option = null;
      this.payload.message = "";
      this.payload.option_return = "";
      this.payload.notification_text = "";
      this.payload.redirection = null;
      this.payload.notification = "";
      this.payload.queue_id = null;
      this.payload.bot_id = null;
    },

    closeDialog(data = false) {
      this.$emit("close:dialog", data);
    },

    async submitForm() {
      this.isLoading = true;

      this.payload = Object.assign({}, this.payload, this.data);

      try {
        const { id, ...payload } = this.payload;
        const { data } = this.isEditMode
          ? await PbxHttpClient.put(`/questions_chat/${id}/update`, payload)
          : await PbxHttpClient.post(
              `/questions_chat/${this.payload.survey_id}/add-question`,
              payload
            );
        this.closeDialog(data.bot);

        this.$snotify.success(
          `Pregunta ${this.isEditMode ? "actualizada" : "creada"} con éxito.`,
          "¡Hecho!"
        );
      } catch (err) {
        this.$snotify.error("No se pudo realizar la acción.", "¡Error!");
      }

      this.isLoading = false;
    }
  }
};
</script>
